import { LS_KEY_TIMEZONE } from 'consts';
import { services } from 'services/base';
import { Timezone } from 'types';
import { getMainConfig, registerStateServices } from 'utils';

const SERVICE_PREFIX = 'appFrame.timezone';

const initTimezoneServices = () => {
  const timezoneStored: Timezone | null = services.appFrame.userStorage.getItem(LS_KEY_TIMEZONE);
  const timezoneDefault = timezoneStored || getMainConfig('defaultTimezone') || Timezone.UTC_WITH_LOCAL;
  const allowTimezoneFromConfig: boolean = getMainConfig('allowTimezone') ?? false;

  const state = {
    timezone: timezoneDefault,
    timezoneAllowed: allowTimezoneFromConfig,
  };

  registerStateServices({
    state,
    stateKey: 'timezone',
    initValue: timezoneDefault,
    servicePrefix: SERVICE_PREFIX,
    serviceMethods: {
      get: 'getTimezone',
      set: 'setTimezone',
      onChange: 'onTimezoneChange',
    },
  });

  registerStateServices({
    state,
    stateKey: 'timezoneAllowed',
    initValue: allowTimezoneFromConfig,
    servicePrefix: SERVICE_PREFIX,
    serviceMethods: {
      get: 'isTimezoneAllowed',
      set: 'setTimezoneAllowed',
      onChange: 'onTimezoneAllowedChange',
    },
  });

  services.appFrame.timezone.onTimezoneChange((timezone: Timezone) => {
    services.appFrame.userStorage.setItem(LS_KEY_TIMEZONE, timezone.toString());
  });

  services.appFrame.userStorage.onUserStorageChange((newStorage) => {
    const timezone = newStorage.getItem(LS_KEY_TIMEZONE) as Timezone;
    if (timezone && timezone !== state.timezone) {
      services.appFrame.timezone.setTimezone(timezone);
    }
  });
};

export default initTimezoneServices;
